


















import {Vue, Component, Prop} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import {nil} from '@/common';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';
@Component({
    components: {
        GenericDialog,
    },
})
export default class CreateOrEditDialog extends Vue {
    public open = false;

    @Prop({default: false})
    public wrapActions!: boolean;
    @Prop({default: false})
    public wide!: boolean;
    @Prop({default: ''})
    public name!: string;
    @Prop({default: () => null})
    public item!: any;

    public get formTitle() {
        return nil(this.item) ? `New ${this.name}` : `Edit ${this.name}`;
    }

    public get formAction() {
        return nil(this.item) ? 'Create' : 'Update';
    }
    public close() {
        this.open = false;
        this.$emit('onClose');
    }
    public submit() {
        this.$emit('onSubmit');
    }
}
